var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlightWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 42,
    cy: 42,
    r: 42,
    transform: "rotate(-180 42 42)",
    fill: "url(#paint0_linear_301_2)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 70C45.8267 70 49.4433 69.265 52.85 67.795C56.2567 66.325 59.2317 64.3183 61.775 61.775C64.3183 59.2317 66.325 56.2567 67.795 52.85C69.265 49.4433 70 45.8267 70 42C70 38.1733 69.265 34.5567 67.795 31.15C66.325 27.7433 64.3183 24.7683 61.775 22.225C59.2317 19.6817 56.2567 17.675 52.85 16.205C49.4433 14.735 45.8267 14 42 14C38.1733 14 34.5567 14.735 31.15 16.205C27.7433 17.675 24.7683 19.6817 22.225 22.225C19.6817 24.7683 17.675 27.7433 16.205 31.15C14.735 34.5567 14 38.1733 14 42C14 45.8267 14.735 49.4433 16.205 52.85C17.675 56.2567 19.6817 59.2317 22.225 61.775C24.7683 64.3183 27.7433 66.325 31.15 67.795C34.5567 69.265 38.1733 70 42 70ZM31.71 55.51L28.56 52.36L39.69 41.16V27.09H43.89V42.84L31.71 55.51Z",
    fill: "#FF8000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_301_2",
    x1: 42,
    y1: 0,
    x2: 42,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.476087,
    stopColor: "#FF8000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8000",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightWarning);
export default __webpack_public_path__ + "static/media/flightWarning.4b34841d554c1f5fd5c61881393aeedd.svg";
export { ForwardRef as ReactComponent };